// WHIT-489: whether the package-tour search runs on our own pages (WHIT-482)
// or hands off to CeSYS as before. A build-time switch: staging.Dockerfile
// turns it on, prod.Dockerfile leaves it off until production has a
// Traveltainment login and booking (WHIT-483) is built. Going live is
// setting it to 'true' in prod.Dockerfile.
// Pure (no DOM, no React) so `node --test web/utils/packageToursSwitch.test.js`
// can load it.

// Only the exact string 'true' turns it on: an unset, empty or mistyped value
// keeps the CeSYS hand-off, which is the safe side.
const isInHouse = value => value === 'true';

module.exports = {
  isInHouse,
  // Read with the full name so Next.js inlines it at build time.
  PACKAGE_TOURS_IN_HOUSE: isInHouse(
    process.env.NEXT_PUBLIC_PACKAGE_TOURS_IN_HOUSE,
  ),
};
